import type { ProspectStatus } from '@agency/website-schema';

export const proposalLifetimeMs = 7 * 24 * 60 * 60 * 1000;

const statusLabels: Record<ProspectStatus, string> = {
  draft: 'Draft proposal',
  sent: 'Proposal sent',
  viewed: 'Proposal viewed',
  changes_requested: 'Changes requested',
  meeting_scheduled: 'Meeting scheduled',
  checkout_started: 'Checkout started',
  purchased: 'Website purchased',
  archived: 'Proposal archived',
};

export function formatProspectPrice(priceCents: number) {
  return (priceCents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
}

export function formatProspectStatus(status: ProspectStatus) {
  return statusLabels[status];
}

export function formatProposalReference(id: string, slug: string) {
  const source = id.replace(/[^a-z0-9]/gi, '') || slug.replace(/[^a-z0-9]/gi, '');
  return `A79-${source.slice(0, 8).toUpperCase()}`;
}

export function getProposalExpiry(createdAt: string) {
  const created = Date.parse(createdAt);
  return (Number.isFinite(created) ? created : Date.now()) + proposalLifetimeMs;
}

export function getProposalPricing(createdAt: string, fullPriceCents: number, promotionPriceCents: number | null, now = Date.now()) {
  const expiresAt = getProposalExpiry(createdAt);
  const promotionActive = promotionPriceCents != null && promotionPriceCents < fullPriceCents && now < expiresAt;
  return {
    expiresAt,
    promotionActive,
    displayPriceCents: promotionActive ? promotionPriceCents : fullPriceCents,
    savingsCents: promotionActive ? fullPriceCents - promotionPriceCents : 0,
  };
}

export function formatPreviewAddress(host: string, slug: string) {
  return `${host}/sites/${slug}`;
}

export function buildProposalPaymentUrl(origin:string,slug:string) {
  const url=new URL(`/sites/${encodeURIComponent(slug)}`,origin);
  url.searchParams.set('checkout','start');
  return url.toString();
}

export function buildImportedPreviewUrl(url:string,viewport:'desktop'|'phone') {
  const [pathAndQuery,hash]=url.split('#',2);
  const separator=pathAndQuery!.includes('?')?'&':'?';
  return `${pathAndQuery}${separator}proposalViewport=${viewport}&proposalMotion=on${hash?`#${hash}`:''}`;
}
